module.exports = __webpack_public_path__ + "img/hnwg.36f380c0.png";